import React from "react";
import {
	Card,
	CardHeader,
	CardBody,
	Form,
	FormGroup,
	Label,
	Input,
	Button,
	Col,
	Row,
} from "reactstrap";
import _ from "lodash";
import ReactSelect from 'react-select';
import DatePicker from "react-datepicker";

export const queryHandler = (searchParams) => {
	let tempSearch = _.cloneDeep(searchParams);
	let tempQuery = {};

	tempSearch.map((searchChild) => {
		if (!_.isEmpty(searchChild.param)) {
			if (searchChild.type === 'checkbox') {
				tempQuery = { ...tempQuery }
				searchChild.param.map(childParam => {
					tempQuery[childParam] = true
				})
			}

			else if (searchChild.type === 'select') {
				tempQuery = {
					...tempQuery,
					[searchChild.value]: searchChild.param === 'true' ? true
						: searchChild.param === 'false'
							? false
							: !searchChild.isSingle
								? searchChild.param
								: [searchChild.param]
				}
			}

			else {
				let tempParam = _.map(searchChild.param, childParam => (
					childParam.label
				))

				tempQuery = {
					...tempQuery,
					[searchChild.value]: !searchChild.isSingle
						? tempParam
						: [searchChild.param?.label]
				}
			}
		}
	});

	console.log(tempQuery)
	return tempQuery;
};


const SearchForm = ({ searchParams, onChangeHOCState, getListAPI, defaultSearchParams, defaultQuery, onReset }) => {
	return (
		<>
			<Card className="main-card mb-3">
				<CardHeader style={{ textTransform: "capital" }}>Search</CardHeader>
				<CardBody>
					<Form onSubmit={(e) => e.preventDefault()}>
						<Row>
							{searchParams.map((item, index) => {
								return (
									<Col key={index} md={item.col || 12} xs={12}>
										{
											(item.type !== 'checkbox' && item.type !== 'radio') && (
												<FormGroup key={item.value}>
													<Label>{item.label}</Label>
													{item.type === "select" && (
														<Input
															type={"select"}
															value={item.param}
															onChange={(e) => {
																let tmp = _.cloneDeep(searchParams);



																tmp[index]["param"] = e.target.value;
																onChangeHOCState("searchParams", tmp);
															}}>
															<option></option>
															{item.options.map((data) => (
																<option key={data.id} value={data.id}>
																	{data.name}
																</option>
															))}
														</Input>
													)}

													{item.type === "multi-select" && (
														<ReactSelect
															options={item.options}
															onChange={val => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = val;
																onChangeHOCState("searchParams", tmp);
															}}
															isMulti={!item.isSingle}
															value={item.param}
														/>
													)}

													{!item.type && (
														<Input
															type={"text"}
															value={item.param}
															onChange={(e) => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = e.target.value;
																onChangeHOCState("searchParams", tmp);
															}}
														/>
													)}
													{item.type === "date" && (
														<DatePicker
															dateFormat="dd-MM-yyyy"
															showYearDropdown
															selected={
																item.param === null ? null : new Date(item.param)
															}
															className="form-control"
															onChange={(val) => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = val;
																onChangeHOCState("searchParams", tmp);
															}}
														/>
													)}
												</FormGroup>
											)
										}
										{item.type === "radio" && (
											<div className="d-flex flex-wrap" style={{ gap: 20 }}>
												{
													item.options.map(optionChild => (
														<FormGroup check>
															<Input
																className="mr-2"
																type={'radio'}
																checked={item.param === optionChild.id}
																onChange={e => {
																	let tmp = _.cloneDeep(searchParams);
																	tmp[index]["param"] = optionChild.id;
																	onChangeHOCState("searchParams", tmp);
																}}
															/>
															<Label check>
																{optionChild.name}
															</Label>
														</FormGroup>
													))
												}
											</div>
										)}
										{
											item.type === 'checkbox' && (
												<div className="d-flex" style={{ gap: 20 }}>
													{
														item.options.map(optionChild => (
															<FormGroup check>
																<Input
																	type={"checkbox"}
																	checked={item.param.indexOf(optionChild.id) > -1}
																	check
																	onChange={(e) => {
																		let tmp = _.cloneDeep(searchParams);
																		let tempIndex = _.findIndex(tmp[index].param, val => val === optionChild.id)

																		if (tempIndex < 0) {
																			tmp[index].param = [
																				...tmp[index].param,
																				optionChild.id
																			]
																		} else {
																			tmp[index].param.splice(tempIndex, 1)
																		}

																		onChangeHOCState("searchParams", tmp);
																	}}>
																	<option></option>
																	{item.options.map((data) => (
																		<option key={data.id} value={data.id}>
																			{data.name}
																		</option>
																	))}
																</Input>
																<Label check>
																	{optionChild.name}
																</Label>
															</FormGroup>
														))
													}
												</div>
											)
										}
									</Col>
								);
							})}
						</Row>
						<div className="d-flex">
							<Button
								color="primary"
								style={{ marginLeft: "auto" }}
								disabled={_.isEmpty(searchParams[1].param)}
								onClick={async () => {
									onChangeHOCState("pageIndex", 1);
									let tempQuery = await queryHandler(searchParams);
									getListAPI({
										page: 1,
										is_paginated: true,
										filter: tempQuery
									});
								}}>
								Search
							</Button>
							<Button
								color="danger"
								style={{ marginLeft: "10px" }}
								onClick={async () => {
									onReset()
									let tmp = [];
									let tmpSearchParams = _.cloneDeep(searchParams);
									tmpSearchParams.map((item) => {
										tmp.push({
											...item,
											param: item.type === "date" ? item.defaultVal : "",
										});
									});
									onChangeHOCState("searchParams", defaultSearchParams ? defaultSearchParams : tmp);
									onChangeHOCState("pageIndex", 1);
									// getListAPI(defaultQuery ? defaultQuery : {
									// 	page: 1,
									// 	is_paginated: true
									// });
								}}>
								Reset
							</Button>
						</div>
					</Form>
				</CardBody>
			</Card>
		</>
	);
};

export default SearchForm;
